/**
 * Probe 상태의 표시 어휘.
 *
 * 색은 c6 status 도메인 그룹 `job` **하나로 완결**한다 — 한 상태 대상의 어휘를 여러 그룹에
 * 섞지 않는다(RFC-status-token-layering §Layer 2, 규칙 §14). ProbeRun 은 claim · lease · attempt 를
 * 가진 작업이라 `job` 이 맞는 그룹이고, 뒤 슬라이스의 분석 · POC 상태도 같은 그룹에서 잇는다.
 *
 * Owns:
 * - 상태 → 라벨 · tone · 안내 문장.
 *
 * Does not own:
 * - 실패 사유 — `probeFailureMessage.ts`. 폴링 — `probePolling.ts`.
 */
import type { StatusTone } from "@/shared/ui/status";
import type { ProbeState } from "../domain/probe";

export type ProbeStatusView = {
  label: string;
  tone: StatusTone;
  /** 상태 배너 본문. 실패는 사유가 따로 있어 짧게 둔다. */
  description: string;
};

const VIEW_BY_STATE: Record<ProbeState, ProbeStatusView> = {
  requested: {
    label: "수집 대기",
    tone: "job.pending",
    description: "수집 대기 중입니다. Worker 가 곧 이 작업을 가져갑니다.",
  },
  collecting: {
    label: "수집 중",
    tone: "job.running",
    description: "샘플을 수집하고 있습니다.",
  },
  sample_ready: {
    label: "샘플 확보",
    tone: "job.succeeded",
    description: "샘플을 확보했습니다.",
  },
  failed: {
    label: "실패",
    tone: "job.failed",
    // 사유는 `probeFailureMessage` 가 카드에서 말한다 — 배너가 같은 문장을 겹쳐 쓰지 않는다.
    description: "샘플 확보가 실패로 끝났습니다. 아래 사유를 확인해 주세요.",
  },
};

export function probeStatusView(state: ProbeState): ProbeStatusView {
  return VIEW_BY_STATE[state];
}
